import { Tooltip } from '@/ui/Tooltip'
import styles from './AuthorTooltip.module.scss'

export const AuthorTooltip = ({ author, children }: { author: string; children: React.JSX.Element }) => {
    return (
        <Tooltip
            className={styles.container}
            tooltip={<div className={styles.tooltip}>{author}</div>}
            placement="bottom"
        >
            {children}
        </Tooltip>
    )
}
